<template>
  <v-app id="list1">
    <v-main>
      <v-container fluid>

        <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
        </v-row>
        <v-row>    
          <v-col cols="5">
            <v-select v-model="ctrlCodesSelected" :items="ctrlCodes" item-value="ctrl_nr" item-text="ctrl_oms" label="Roles" multiple></v-select>
          </v-col>
        </v-row>      
        <v-row>    
          <v-col cols="5">
            <v-select v-model="statCodesSelected" :items="statCodes" item-value="statCode" item-text="statCode" label="Accommodation Status" multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="5">
            <m_select_gebr_codes 
                label="Agent(s)" 
                field="gebrCodesSelected"
                @updateData="updateData" 
                :selected_gebrcodes="gebrCodesSelected" 
                :localStorageItem="localStorageItemGebr" 
                :isClearable="true"
                :canSelectAll="true" 
                :isMultiple="true" 
                :isAgent="true" 
                />
          </v-col>
        </v-row>

        <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz">Create excel</v-btn>
          </v-col> 
        </v-row>

      </v-container>
    </v-main>

    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    <standard_dialog ref="std_dialog" />  

  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import m_select_gebr_codes from "@/components/ui/selectors/m_select_gebr.vue"
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
  components: {
    navBar,
    standard_dialog,
    m_select_gebr_codes,
  },
  data() {
    return {
      ctrlCodesSelected: [],
      ctrlCodes: [],
      bedrCodesSelected: [],
      bedrCodes: [],
      statCodesSelected: [],
      statCodes: [],
      gebrCodesSelected: [],
      gebrCodes: [],
      param: {},
      localStorageItemGebr: 'list.host.ovrz1.gebrcodes',
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/eign/ovrz/getList1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getList1Param"
        },
        getList1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getList1Param;
           res.data.getList1Param.ctrl_nrKeuzes.forEach(function(ctrl) {
           deze.ctrlCodes.push(ctrl);
            if (ctrl.ctrl_nrSelected === true) {
               deze.ctrlCodesSelected.push(ctrl.ctrl_nr);
            } 
           });
           res.data.getList1Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getList1Param.statKeuzes.forEach(function(stat) {
             deze.statCodes.push(stat.statCode);
             if (stat.statSelected === true) {
                deze.statCodesSelected.push(stat.statCode);
             }
           });
           res.data.getList1Param.gebrKeuzes.forEach(function(gebr) {
             deze.gebrCodes.push(gebr.gebrCode);
             if (gebr.gebrSelected === true) {
                deze.gebrCodesSelected.push(gebr.gebrCode);
             }
           });
        }
      });
  },
  methods: {
     ovrz() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/eign/ovrz/eignExcelExportList1v5.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "eignExcelExportList1"
          },
          eignExcelExportList1: {
            ctrl_nrs: this.ctrlCodesSelected,
            bedr_codes: this.bedrCodesSelected,
            stat_codes: this.statCodesSelected,
            gebr_codes: this.gebrCodesSelected,
          }
        })
        .then(res => {
          if (res.data.error) {
            this.$refs.std_dialog.open('error', 'Error', `${res.data.error.message}`); 
          } else {
            localStorage.setItem(this.localStorageItemGebr, this.gebrCodesSelected);
            if (res.data.eignExcelExportList1v5.color === 'warning') {
              this.$refs.std_dialog.open('warning', 'Warning', `${res.data.eignExcelExportList1v5.text}`); 
            } else {
              this.$refs.std_dialog.open('info', 'Info', `${res.data.eignExcelExportList1v5.text}`); 
            }
          }
        });
    },
    updateData(data) {
        this[data.field] = data.value;
    },
  }
};

</script> 
